import React, {MouseEvent} from 'react';
import copy from "copy-to-clipboard";
import {useLayerPopupContext} from "../../contexts";
import {kick, redirect, removeUsername} from "../../modules";

const InvestmentPrecautions = () => {
  const {
    share: { title, url },
    close
  } = useLayerPopupContext()

  return (
    <article
      className="popup"
      style={{width: "540px", margin: "-155px 0 0 -270px"}}
    >
      <div className="titB">
        <h1>투자유의사항</h1>
        <a
          href="#!"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            close()
          }}
          title="닫기"
        >
          닫기
        </a>
      </div>
      <div className="txtB">
        <div className="roundB txt" style={{textAlign: "left", padding: '5px'}}>
          <ul>
            - 한국경제TV와 파트너는 금융투자업자가 아닌 유사투자자문업자로 개별적인 투자 상담과 자금 운영이 불가합니다. <br/><br/>
            - 본 사이트에서 제공되는 모든 정보는 투자판단의 참고자료로 원금 손실이 발생할 수 있으며, 그 손실은 투자자에게 귀속됩니다.<br/><br/>
            - 또한 파트너가 제공하는 증권 정보는 파트너가 독단적으로 생성한 콘텐츠로 한국경제TV와는 무관합니다.
          </ul>
        </div>
      </div>
      <div className="btnB">
        <a
          href="#!"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            close()
          }}
          className="btn"
          title="닫기"
        >
          닫기
        </a>
      </div>
    </article>
  );
};

export default InvestmentPrecautions;